import React, { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import { FormFiltersBackground, PageMain } from "components/molecules";
import { QUERIES_KEYS } from "queries";
import { UserRegistrationsReportRow, reportsApi } from "api/reportsApi";
import { PaziaDateSelect } from "components/atoms";
import { TanTableClient, useFilters, TanTableColumn } from "components/molecules";
import { formatDate } from "utils";
import { PaziaBreadcrumbs } from "components/atoms";
import { routes } from "consts";
import { REPORTS_IDS, REPORTS_NAMES } from "consts/reports";

export const UserRegistrationsReport = () => {
  const { filter, changeFilter } = useFilters();
  const { data, isLoading, refetch } = useQuery({
    queryKey: QUERIES_KEYS.REPORTS.USER_REGISTRATIONS(),
    queryFn: () => reportsApi.getUserRegistrationsReport(filter),
  });

  useEffect(() => {
    refetch();
  }, [filter]);

  const columns: TanTableColumn<UserRegistrationsReportRow>[] = [
    {
      id: "userEmail",
      accessorKey: "userEmail",
      header: "Użytkownik",
      size: 200,
    },
    {
      id: "createdDate",
      accessorKey: "createdDate",
      header: "Zarejestrowano",
      cell: (info) => formatDate(info.getValue<Date>(), true, true),
    },
    {
      id: "firstName",
      accessorKey: "firstName",
      header: "Imię",
    },
    {
      id: "surname",
      accessorKey: "surname",
      header: "Nazwisko",
    },
    {
      id: "pesel",
      accessorKey: "pesel",
      header: "PESEL",
    },
    {
      id: "phone",
      accessorKey: "phone",
      header: "Telefon",
    },
  ];

  const onFromDateChange = (date: Date | null) =>
    changeFilter("from", date ? `createdDate ge ${date.toISOString()}` : "");

  const onToDateChange = (date: Date | null) => changeFilter("to", date ? `createdDate le ${date.toISOString()}` : "");

  const tableData = data?.data ?? [];
  return (
    <PageMain>
      <PaziaBreadcrumbs
        segments={[
          { title: "Raporty", path: routes.REPORTS },
          { title: REPORTS_NAMES[REPORTS_IDS.USER_REGISTRATIONS] },
        ]}
      />
      <FormFiltersBackground>
        <div className="flex flex-wrap items-center gap-2">
          <PaziaDateSelect name="dateFrom" label="Data od" onChange={onFromDateChange} />
          <PaziaDateSelect name="dateTo" label="Data od" onChange={onToDateChange} />
        </div>
      </FormFiltersBackground>
      <div>
        <TanTableClient
          data={tableData}
          columns={columns}
          exportCsv
          csvFields={["userEmail", "createdDate", "firstName", "surname", "pesel", "phone"]}
        />
      </div>
    </PageMain>
  );
};
